import {
  documentTypesLocales as libDocumentTypesLocales,
  SHINE_START_DOCUMENT_TYPES,
} from '@shinetools/shine-start-library';
import LocalizedStrings from 'localized-strings';

import {
  CompanyCreationDocumentType,
  ShineStartDocumentType,
} from '../../../../../../__generated__/GQL';
import locales from './locales';

const documentTypesLocales = new LocalizedStrings(libDocumentTypesLocales);

const getShineStartDocumentLabel = (document: {
  type: ShineStartDocumentType | CompanyCreationDocumentType;
  typeLocalized?: string | null;
}): string => {
  if (document.type === null) {
    return locales.fallbackDocumentName;
  }
  if (
    document.typeLocalized &&
    document.type === SHINE_START_DOCUMENT_TYPES.GENERIC
  ) {
    return document.typeLocalized;
  }
  const locale = documentTypesLocales[document.type];
  if (locale) {
    return locale.label;
  }
  return document.typeLocalized ?? locales.fallbackDocumentName;
};

export default getShineStartDocumentLabel;
